import { Typography } from "@mui/material";

interface FieldLabelProps {
  children: string | string[];
  fontWeight?: number;
  fontSize?: number;
  required?: boolean;
}

export default function FieldLabel(props: FieldLabelProps) {
  return (
    <Typography
      fontWeight={props.fontWeight ?? 400}
      fontSize={props.fontSize ?? 14}
      color="primary"
    >
      {props.children}
      {props.required && props.children && (
        <Typography sx={{ display: "inline-block", color: "primary" }}>
          *
        </Typography>
      )}
    </Typography>
  );
}
